import { FC, MouseEventHandler, ReactNode } from 'react';

import { InnerBox, Root } from './styled';

export interface IStyledTicketWrapperProps {
	leftSide: ReactNode;
	rightSide: ReactNode;
	onClick?: MouseEventHandler;
	dataTestId?: string;

	/**
	 * Color(s) filling the two notches cut into the ticket's left edge. The
	 * notches read as cut-outs only when they match the surface behind the
	 * ticket => Pass the color of the screen the wrapper sits on.
	 * Use a single color for a flat background, or `{ top, bottom }` for a gradient surface.
	 * Defaults to the DTicket overview colors so existing usages are unchanged.
	 *
	 * If needed, it can be simplified when we switch from old Tickets tab to Activities
	 */
	notchColor?: string | { top?: string; bottom?: string };
}

export const StyledTicketWrapper: FC<IStyledTicketWrapperProps> = ({
	leftSide,
	rightSide,
	onClick,
	dataTestId,
	notchColor,
}) => {
	const topNotchColor =
		typeof notchColor === 'string' ? notchColor : notchColor?.top;
	const bottomNotchColor =
		typeof notchColor === 'string' ? notchColor : notchColor?.bottom;

	return (
		<Root onClick={onClick}>
			<InnerBox
				data-testid={dataTestId}
				topNotchColor={topNotchColor}
				bottomNotchColor={bottomNotchColor}
			>
				<div className="slot">{leftSide}</div>
				<div className="dashes" />
				<div className="slot">{rightSide}</div>
			</InnerBox>
		</Root>
	);
};
